(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-read-more')) {
    customElements.define(
      'product-read-more',
      class ProductReadMore extends HTMLElement {
        connectedCallback() {
          this.text = this.querySelector('.product-read-more__text');
          this.button = this.querySelector('.product-read-more__button');
          this.details = this.closest('details');

          if (!this.text || !this.button) return;

          this.handleToggle = () => {
            const expanded = this.dataset.expanded === 'true';
            this.dataset.expanded = String(!expanded);
            this.button.setAttribute('aria-expanded', String(!expanded));

            if (!expanded) {
              this.dataset.overflow = 'true';
            } else {
              requestAnimationFrame(() => this.updateOverflow());
            }
          };

          this.updateOverflow = () => {
            if (this.dataset.expanded === 'true') return;

            const overflow = this.text.scrollHeight > this.text.clientHeight + 1;
            this.dataset.overflow = String(overflow);
            this.button.hidden = !overflow;
          };

          this.handleDetailsToggle = () => {
            if (this.details?.open) requestAnimationFrame(() => this.updateOverflow());
          };

          this.button.addEventListener('click', this.handleToggle);
          this.details?.addEventListener('toggle', this.handleDetailsToggle);
          window.addEventListener('resize', this.updateOverflow);
          requestAnimationFrame(() => this.updateOverflow());
          document.fonts?.ready.then(() => this.updateOverflow());
        }

        disconnectedCallback() {
          this.button?.removeEventListener('click', this.handleToggle);
          this.details?.removeEventListener('toggle', this.handleDetailsToggle);
          window.removeEventListener('resize', this.updateOverflow);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
